import { ArrowDownSvg, ArrowUpSvg } from '../assets/icons';
import TimerSvg from '../assets/icons/TimerSvg';
import { SortDropdownOption } from '../components/_molecules/SortDropdown';

const cacheKey = '@curipod-v1-sort';

export const initSortCondition = () => {
  try {
    const cache = localStorage.getItem(cacheKey);
    if (!cache) return sortOptions[0];
    const value = JSON.parse(cache) as string;
    const option = sortOptions.find(option => option.value === value);
    return option || sortOptions[0];
  } catch (e) {
    return sortOptions[0];
  }
};

export const saveSortCondition = (option: SortDropdownOption) => {
  localStorage.setItem(cacheKey, JSON.stringify(option.value));
};

export const sortOptions: SortDropdownOption[] = [
  {
    displayName: 'Newest edited',
    value: 'newestModified',
    icon: <TimerSvg />,
  },
  {
    displayName: 'Oldest edited',
    value: 'oldestModified',
    icon: <TimerSvg />,
  },
  {
    displayName: 'Alphabetical (A-Z)',
    value: 'alphaAsc',
    icon: <ArrowUpSvg />,
  },
  {
    displayName: 'Alphabetical (Z-A)',
    value: 'alphaDesc',
    icon: <ArrowDownSvg />,
  },
];

export const searchSortOptions: SortDropdownOption[] = [
  {
    displayName: 'Most relevant',
    value: 'mostRelevant',
    icon: <ArrowDownSvg />,
  },
];
